<template>
    <v-dialog v-model="value" persistent max-width="600px" scrollable class="scrollDesign">
        <v-card>
            <v-card-title class="headline gradiente lighten-2 elevation-3">
                <span class="white--text">Detener Encuesta</span>
            </v-card-title>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-card-text style="">
                            <p style="font-size: 18px; text-align: center;">Estás a punto de detener la encuesta.</p>

                            <p style="font-size: 18px; text-align: center;">Si realizas esta acción la encuesta ya no será enviada a los tutores y los QR's de alumnos no requerirán responderla para su ingreso. Podrás reanudar la encuesta cuando lo desees, mientras no haya llegado su fecha y hora de término.</p>
                            <p style="font-size: 15px; text-align: center;">¿Deseas continuar y detener la encuesta?</p>
                        </v-card-text>

                        <v-card-actions style="justify-content: center;">
                            <v-btn color="primary" small @click="close" style="padding: 17px; margin-right: 17px;">CANCELAR</v-btn>
                            <v-btn color="black" small @click="imput" style="padding: 17px; margin-left: 17px; color: white; background: black;">DETENER</v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <loading v-model="toast.loading" text="Trabajando..."></loading>
        <success v-model="toast.success" text="QR Bloqueado correctamente"></success>
        <error v-model="toast.failed" :text="toast.fmessage"></error>
        <help v-model="helpDialog.flag" :title="helpDialog.title" :description="helpDialog.description"></help>
    </v-dialog>
</template>

<script>
import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";
import help from "../Dialogs/Help2.vue";
export default {
    components: {
        loading,
        success,
        error,
        help,
    },
    data: () => ({
        obj:{
            disable: true,
            reason: "",
            id:"",
        },
        toast: {
            loading: false,
            success: false,
            failed: false,
            fmessage: "Ups ocurrió un error"
        },
        helpDialog: {
			title: "",
			description: "",
			flag: false
        },
    }),

    props: ["value","poll"],
    methods: {
        close() {
            this.obj.reason = "";
            this.$emit("input", !this.value);
        },
        imput(){
            this.$store
                .dispatch("polls/StopPoll", this.poll)
                .then(() => {
                    this.toast.failed = true;
                    this.working.wLoading = false;
                    this.helpDialog.title = "";
                    this.helpDialog.description = "Error al detener encuesta";
                    this.helpDialog.flag = true;   
                })
                .catch(() => {
                    this.toast.success = true;
                    this.$emit("updated");
                    this.close();
                });
        },
    },
    watch: {

    },
}
</script>


<style>

</style>